import type { FPlusExpressionValue } from '../../types/templateModel'
import { FPlusConstructorExpressionEditor } from '../fplusEditor/customEditor/FPlusConstructorExpressionEditor'
import { FPlusLiteralExpressionEditor } from '../fplusEditor/customEditor/FPlusLiteralExpressionEditor'
import type { ExpressionTypeInformation } from './types'

type Props = {
  typeInformation: ExpressionTypeInformation
  onCancel: () => void
  onChangeCode: (nextValue: FPlusExpressionValue) => void
  initialHeightPx: number
  isTransparent: boolean
  expressionPath: string
}

export const FPlusCustomExpressionEditor = ({
  typeInformation,
  ...props
}: Props) => {
  switch (typeInformation.type) {
    case 'literal':
      return (
        <FPlusLiteralExpressionEditor
          {...props}
          typeInformation={typeInformation}
        />
      )
    case 'constructor':
      return (
        <FPlusConstructorExpressionEditor
          {...props}
          typeInformation={typeInformation}
        />
      )
  }
}
